import * as React from 'react';

import { translate } from '~l10n/client';

export const PauseIcon = React.forwardRef<
  SVGSVGElement,
  {
    className?: string;
  }
>(function PauseIcon({ className }, ref) {
  return (
    <div className={className}>
      <svg
        width={12}
        height={12}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label={translate('Paused Activity')}
        data-testid="activity-status-paused"
        ref={ref}
      >
        <rect x="2" width="3" height="10" rx="1" fill="currentColor" />
        <rect x="7" width="3" height="10" rx="1" fill="currentColor" />
      </svg>
    </div>
  );
});
